import { ArrowLeft, CheckCircle2 } from "@/components/icons"
import { Button } from "@/components/ui/button"

import { FEASIBILITY_MAP, type UseCaseFormData } from "../../types/use-case.types"

type WizardSummaryCardProps = {
  data: UseCaseFormData
  onConfirm: () => void
  onBack: () => void
}

function truncate(text: string, max: number) {
  if (!text || text.length <= max) return text
  return text.slice(0, max).trimEnd() + "..."
}

export function WizardSummaryCard({ data, onConfirm, onBack }: WizardSummaryCardProps) {
  const feas = FEASIBILITY_MAP[data.feasV] ?? FEASIBILITY_MAP["2"]
  const unitLabels: Record<string, string> = { week: "h/week", month: "h/month" }
  const hourLabel = `${data.timeSavedHours}${unitLabels[data.timeSavedUnit] ?? "h (once)"}`

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Review your use case</h3>

      <div className="space-y-3 rounded-lg border p-4">
        <div>
          <div className="text-muted-foreground text-xs font-medium uppercase">Name</div>
          <div className="font-medium">{data.ucName || "Untitled"}</div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <div className="text-muted-foreground text-xs font-medium uppercase">Problem</div>
            <div className="text-sm">{truncate(data.issue, 180) || "—"}</div>
          </div>
          <div>
            <div className="text-muted-foreground text-xs font-medium uppercase">Solution</div>
            <div className="text-sm">{truncate(data.solutionDesc, 180) || "—"}</div>
          </div>
        </div>

        <div className="flex gap-6">
          <div>
            <div className="text-muted-foreground text-xs font-medium uppercase">Feasibility</div>
            <span className="text-sm font-medium" style={{ color: feas.color }}>
              {feas.label}
            </span>
          </div>
          <div>
            <div className="text-muted-foreground text-xs font-medium uppercase">Time Saved</div>
            <div className="text-sm">{hourLabel}</div>
          </div>
          <div>
            <div className="text-muted-foreground text-xs font-medium uppercase">Users</div>
            <div className="text-sm">{data.users || "0"}</div>
          </div>
        </div>
      </div>

      <div className="flex justify-between">
        <Button variant="ghost" onClick={onBack}>
          <ArrowLeft className="mr-1 size-4" />
          Back
        </Button>
        <Button onClick={onConfirm}>
          <CheckCircle2 className="mr-1 size-4" />
          Edit in Fact Sheet
        </Button>
      </div>
    </div>
  )
}
